import { useState } from "react";
import { ToolBtn } from "../ToolBtn";
import secondaryComponents from "../..";
import primaryComponents from "../../../primaryComponents";
import { useCheckoutHelper } from "../../../../hooks/useCheckoutHelper";

export const CheckoutOrderType = ({ btnStyle }) => {
  const [isOrderType, setIsOrderType] = useState(false);
  const { order_type, setOrderType } = useCheckoutHelper();

  return (
    <>
      <div className="w-100">
        <ToolBtn
          text="Order Type"
          borderColor={"transparent"}
          onClick={() => setIsOrderType(true)}
          style={btnStyle}
          contentText={
            order_type === "DINE_IN"
              ? "Dine In"
              : order_type === "TAKE_OUT"
                ? "Take Out"
                : null
          }
        />
      </div>

      <secondaryComponents.Modal
        isActive={isOrderType}
        width={500}
        closeModal={() => setIsOrderType(false)}
      >
        <div className="d-flex flex-column p-2" style={{ gap: "15px" }}>
          <div>
            <h4 className="mb-0">Select Order Type</h4>
            <hr />
          </div>

          <div className="d-flex flex-column w-100" style={{ gap: "10px" }}>
            <primaryComponents.BoxedRadioInput
              style={{ height: "40px" }}
              isChecked={order_type === "DINE_IN"}
              setRadioValue={() => setOrderType("DINE_IN")}
              name="order_type"
            >
              Dine-in
            </primaryComponents.BoxedRadioInput>
            <primaryComponents.BoxedRadioInput
              name="order_type"
              style={{ height: "40px" }}
              isChecked={order_type === "TAKE_OUT"}
              setRadioValue={() => setOrderType("TAKE_OUT")}
            >
              Take-out
            </primaryComponents.BoxedRadioInput>
          </div>

          <primaryComponents.Button
            classNames={"btn btn--primary cover mt-3"}
            onClick={() => setIsOrderType(false)}
          >
            Continue
          </primaryComponents.Button>
        </div>
      </secondaryComponents.Modal>
    </>
  );
};
